export default __webpack_public_path__ + "static/media/timeline-delivery-image.ef72da9a.png";